import { supabase } from '@/lib/supabase';

export const favoriteService = {
  /**
   * Get user favorites
   */
  async getFavorites() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase
      .from('favorites')
      .select('*, vehicle:vehicles(*)')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false });

    if (error) throw new Error(error.message);
    return data || [];
  },

  /**
   * Add to favorites
   */
  async addFavorite(vehicleId: string) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase
      .from('favorites')
      .insert({
        user_id: user.id,
        vehicle_id: vehicleId,
      })
      .select('*, vehicle:vehicles(*)')
      .single();

    if (error) {
      // If already favorited, return existing
      if (error.code === '23505') {
        return await this.getFavorite(vehicleId);
      }
      throw new Error(error.message);
    }

    return data;
  },

  /**
   * Remove from favorites
   */
  async removeFavorite(vehicleId: string) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');

    const { error } = await supabase
      .from('favorites')
      .delete()
      .eq('user_id', user.id)
      .eq('vehicle_id', vehicleId);

    if (error) throw new Error(error.message);
  },

  /**
   * Check if vehicle is favorited
   */
  async getFavorite(vehicleId: string) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return null;

    const { data, error } = await supabase
      .from('favorites')
      .select('*, vehicle:vehicles(*)')
      .eq('user_id', user.id)
      .eq('vehicle_id', vehicleId)
      .single();

    if (error) return null;
    return data;
  },
};

